
import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

interface NavItemProps {
  name: string;
  link: string;
  scrolled: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const NavItem: React.FC<NavItemProps> = ({ name, link, scrolled, className, onClick }) => {
  return (
    <li>
      <NavLink
        to={link}
        className={({ isActive }) =>
          cn(
            "whitespace-nowrap px-2 xl:px-3 py-2 rounded-md text-xs xl:text-sm font-medium transition-colors",
            isActive
              ? "text-primary font-semibold"
              : scrolled
              ? "text-joerg-700 hover:text-primary hover:bg-joerg-50"
              : "text-joerg-800 hover:text-primary hover:bg-white/70",
            className
          )
        }
        onClick={onClick}
      >
        {name}
      </NavLink>
    </li>
  );
};

export default NavItem;
